var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock_svg__clip0_487_19394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2.91C6.47 2.91 2 7.39 2 12.91s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10s-4.48-10-10.01-10zm.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7.91z",
    fill: "#000",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_svg__clip0_487_19394"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .91)",
    d: "M0 0h24v24H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQ4N18xOTM5NCkiPgo8cGF0aCBkPSJNMTEuOTkgMi45MTAxNkM2LjQ3IDIuOTEwMTYgMiA3LjM5MDE2IDIgMTIuOTEwMkMyIDE4LjQzMDIgNi40NyAyMi45MTAyIDExLjk5IDIyLjkxMDJDMTcuNTIgMjIuOTEwMiAyMiAxOC40MzAyIDIyIDEyLjkxMDJDMjIgNy4zOTAxNiAxNy41MiAyLjkxMDE2IDExLjk5IDIuOTEwMTZaTTEyIDIwLjkxMDJDNy41OCAyMC45MTAyIDQgMTcuMzMwMiA0IDEyLjkxMDJDNCA4LjQ5MDE2IDcuNTggNC45MTAxNiAxMiA0LjkxMDE2QzE2LjQyIDQuOTEwMTYgMjAgOC40OTAxNiAyMCAxMi45MTAyQzIwIDE3LjMzMDIgMTYuNDIgMjAuOTEwMiAxMiAyMC45MTAyWk0xMi41IDcuOTEwMTZIMTFWMTMuOTEwMkwxNi4yNSAxNy4wNjAyTDE3IDE1LjgzMDJMMTIuNSAxMy4xNjAyVjcuOTEwMTZaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjg3Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNDg3XzE5Mzk0Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjkxMDE1NikiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgClock as ReactComponent };